import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Col, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { formatUnitWaranty, getShippingTypes, getProductStatus } from 'helpers/format'
import { ApproveDetailReq, UpdateRequestStatusReq } from 'Store/product/types'
import { getApproveProductDetailAPI, updateRequestStatusAPI } from 'Store/product/api'
import {
  selectActionEvent,
  selectApproveProductDetail,
  selectApproveProductEvent,
} from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { MultiUploadForm } from 'Components/form'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/product/actions'
import { DetailDrawer } from 'Components/common/MainLayout'
import { ProductStatus } from 'helpers/constanst'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { ProductOptions } from './components'
import { ConfirmDailog, ConfirmQuestion } from 'Components/modal'
import { StatusTag } from 'Components/utilities'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  logId: number
}

const ProductRequestDetail: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, event, onSuccess = () => {}, detail, currentUser, logId } = props

  const [rejectDialog, setRejectDialog] = useState(false)
  const [approveDialog, setApproveDialog] = useState(false)
  const dispatch = useDispatch()

  const onReject = (reason: string): void => {
    setRejectDialog(false)
    const req: UpdateRequestStatusReq = {
      log_id: logId,
      status: 'rejected',
      reason,
    }
    dispatch(updateRequestStatusAPI(req, currentUser.accessToken))
  }

  const onApprove = (): void => {
    setApproveDialog(false)
    const req: UpdateRequestStatusReq = {
      log_id: logId,
      status: 'approved',
    }
    dispatch(updateRequestStatusAPI(req, currentUser.accessToken))
  }

  const onGetDetail = (): void => {
    const req: ApproveDetailReq = {
      log_id: logId,
    }
    dispatch(
      getApproveProductDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    console.log('onEventSuccess')
    setRejectDialog(false)
    setApproveDialog(false)
    clearEvent()
    onSuccess()
  }

  useEffect(() => {
    if (logId) {
      onGetDetail()
    }
  }, [logId])

  const renderInfo = (title: string, value: any, span: number = 15) => {
    return (
      <Row justify="space-between" style={{ marginBottom: '6px' }}>
        <Col>
          <InfoTitle>{title}</InfoTitle>
        </Col>
        <Col span={span} offset={1}>
          <InfoValue>{value || '-'}</InfoValue>
        </Col>
      </Row>
    )
  }

  const renderProductStatus = (status?: string) => (
    <StatusTag
      isPass={status === ProductStatus.ACTIVE}
      text={getProductStatus(status || ProductStatus.ACTIVE)}
    />
  )

  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="อนุมัติสินค้า" btnType="Approve" onClick={() => setApproveDialog(true)} />
      <PrimaryButton text="ไม่อนุมัติสินค้า" btnType="Reject" onClick={() => setRejectDialog(true)} />
    </Space>
  )

  const ConfirmRejectDailog = (
    <ConfirmQuestion
      title="ไม่อนุมัติสินค้า"
      placeholder="เช่น รูปภาพสินค้าไม่ชัด..."
      confirmBtnTxt="ไม่อนุมัติ"
      isShow={rejectDialog}
      handleOk={(remark: string) => onReject(remark)}
      handleCancel={() => setRejectDialog(false)}
      loading={event.IsLoading}
    />
  )

  const ConfirmApproveDailog = (
    <ConfirmDailog
      title="ยืนยันอนุมัติสินค้า"
      description="คุณแน่ใจที่จะอนุมัติสินค้านี้หรือไม่?"
      confirmBtnTxt="อนุมัติ"
      isShow={approveDialog}
      handleOk={onApprove}
      handleCancel={() => setApproveDialog(false)}
      loading={event.IsLoading}
    />
  )

  const waranty =
    detail?.warranty_status === 'off'
      ? 'ไม่มี'
      : 'รับประกัน ' + detail?.product_warranty + ' ' + formatUnitWaranty(detail?.product_warranty_unit || '')
  const refund =
    detail?.refund_status === 'off'
      ? 'ไม่มี'
      : 'ภายใน ' + detail?.product_refund + ' ' + formatUnitWaranty(detail?.product_refund_unit || '')

  return (
    <DetailDrawer
      title={'อนุมัติสินค้า'}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width={'80%'}
      maskClosable={true}
    >
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row justify="space-between" gutter={[16, 16]}>
        <Col md={12} xs={24}>
          <Title>รายละเอียดคำร้องขอ</Title>
          {renderInfo('ชื่อร้านค้า', detail?.merchant_name || '')}
          {renderInfo('เหตุผลขอแก้ไข', detail?.update_remark || 'เพิ่มสินค้าใหม่')}
        </Col>
        <Col md={24} xs={24}>
          <Title>รายละเอียดสินค้า</Title>
          <MultiUploadForm
            label="รูปภาพสินค้า"
            token={''}
            onUpdateData={() => {}}
            files={detail?.photos || []}
            listType="picture-card"
            name="photos"
            readOnly={true}
          />
        </Col>
        <Col md={12} xs={24}>
          {renderInfo('ชื่อสินค้า', detail?.title)}
          {renderInfo('รหัสสินค้า', detail?.code)}
          {renderInfo(
            'หมวดหมู่สินค้า',
            `${detail?.group_name}/${detail?.category_name}/${detail?.sub_category_name}`,
          )}
          {renderInfo('รุ่น', detail?.model)}
          {renderInfo('หน่วย', detail?.uom_name)}
          {renderInfo('รายละเอียดสินค้า', detail?.details)}
        </Col>
        <Col md={12} xs={24}>
          {renderInfo('วิธีการใช้งาน', detail?.manual)}
          {renderInfo('การบำรุงรักษา', detail?.maintenant_and_caution)}
          {renderInfo('คุณสมบัติสินค้า', detail?.properties)}
        </Col>
        <Col md={24} xs={24}>
          <ProductOptions formData={detail} />
        </Col>
        <Col md={12} xs={24}>
          <Title>ตั้งค่าสินค้า</Title>
          {renderInfo('การรับประกัน', waranty)}
          {renderInfo('รับคืนสินค้า', refund)}
          {renderInfo('ช่องทางการจัดส่ง', getShippingTypes(detail?.shipping_types || []))}
          {renderInfo('สถานะสินค้า', renderProductStatus(detail?.status))}
          {renderInfo('สถานะสินค้าบน Terminal', renderProductStatus(detail?.status_pos))}
        </Col>
      </Row>
      {ConfirmRejectDailog}
      {ConfirmApproveDailog}
    </DetailDrawer>
  )
}

const Title = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-weight: 500;
`

const InfoTitle = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const InfoValue = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectActionEvent(state),
    detailEvent: selectApproveProductEvent(state),
    detail: selectApproveProductDetail(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ProductRequestDetail)
